import { api } from '../../api'

export const checkoutInfoQueryKey = 'checkout-info'

export const checkoutInfoQuery = (session: string) => ({
  queryKey: ['checkout-info'],
  queryFn: () => api.getCheckoutInfo(session),
})
